export default __webpack_public_path__ + "static/media/car1.faf7d7f4.png";